import type { ReactNode } from 'react';
import { useState } from 'react';

import { KycRenewalRequiredDialog } from '#src/components/fiatWallet/KycRenewalRequiredDialog/index.tsx';

import { KycRenewalRequiredContext } from './index.ts';

type Props = {
  children: ReactNode;
};

export const KycRenewalRequiredProvider = ({ children }: Props) => {
  const [showKycRenewalRequired, setShowKycRenewalRequired] = useState(false);

  return (
    <KycRenewalRequiredContext
      value={{
        showKycRenewalRequired,
        setShowKycRenewalRequired,
      }}
    >
      {children}
      <KycRenewalRequiredDialog
        open={showKycRenewalRequired}
        onClose={() => setShowKycRenewalRequired(false)}
      />
    </KycRenewalRequiredContext>
  );
};
